import { CompanyAccess } from "../models/companyAccess";

export const companyAccessTabs: CompanyAccess[] = [
  { name: 'Details' },
  { name: 'Collection' },
  { name: 'Audit 1' },
  { name: 'Audit 2' },
  { name: 'Board' },
  { name: 'Committees' },
  { name: 'Ownership' },
  { name: 'Family' },
  { name: 'Salary 1' },
  { name: 'Salary 2' },
  { name: 'Accounting' },
  { name: 'Society' },
  { name: 'Employees' },
  { name: 'Energy & Water' },
  { name: 'Emissions & Waste' },
  { name: 'Voting Results' },
  { name: 'Messages' },
  { name: 'Status' }
];
